import React, { Component } from 'react'
import moment from 'moment'
import Footer from '../newoffice/Footer'
import Header from '../newoffice/Header'
import ShowCard from '../newoffice/ShowCard'
import '../static/css/style.css'
import '../static/css/newoffice.css'

export default class NewOffice extends Component {
  constructor () {
    super()
    this.state = {
      organizador: {
        id: 97,
        name: 'New Office'
      },
      events: [{
        id: '1841',
        eventName: 'Caxias do Sul/RS',
        address: 'R. Ludovíco Cavinato, 1431 - Nossa Sra. da Saúde, Caxias do Sul - RS, 95032-620',
        startDate: '2020-07-18T03:00:00.000Z',
        endDate: '2020-07-19T03:00:00.000Z',
        urlFriendly: 'new-office-caxias-do-sul-rs'
      }, {
        id: '1842',
        eventName: 'Chapecó/SC',
        address: 'R. Sete de Setembro, 150 - Pres. Medici, Chapecó - SC, 89801-145',
        startDate: '2020-07-21T03:00:00.000Z',
        endDate: '2020-07-22T03:00:00.000Z',
        urlFriendly: 'new-office-chapeco-sc'
      }, {
        id: '1843',
        eventName: 'Maringá/PR',
        address: 'Av. XV de Novembro, 470 - Zona 01, Maringá - PR, 87013-230',
        startDate: '2020-07-24T03:00:00.000Z',
        endDate: '2020-07-25T03:00:00.000Z',
        urlFriendly: 'new-office-maringa-pr'
      }, {
        id: '1840',
        eventName: 'Curitiba/PR',
        address: 'R. Pergentina Silva Soares, 159 - Jardim Botânico, Curitiba - PR, 80210-410',
        startDate: '2020-08-11T03:00:00.000Z',
        endDate: '2020-08-12T03:00:00.000Z',
        urlFriendly: 'new-office-curitiba-pr'
      }, {
        id: '1844',
        eventName: 'Camboriú/SC',
        address: 'Av. das Arapongas, 700 - Ariribá, Balneário Camboriú - SC',
        startDate: '2020-08-14T03:00:00.000Z',
        endDate: '2020-08-15T03:00:00.000Z',
        urlFriendly: 'new-office-camboriu-sc'
      }, {
        id: '1845',
        eventName: 'Salvador/BA',
        address: 'Praça Stella Maris, 200 - Stella Maris, Salvador - BA, 41600-500',
        startDate: '2020-08-18T03:00:00.000Z',
        endDate: '2020-08-19T03:00:00.000Z',
        urlFriendly: 'new-office-salvador-ba'
      }, {
        id: '1846',
        eventName: 'Fortaleza/CE',
        address: 'Av. Beira Mar, 2500 - Meireles, Fortaleza - CE, 60165-121',
        startDate: '2020-08-21T03:00:00.000Z',
        endDate: '2020-08-22T03:00:00.000Z',
        urlFriendly: 'new-office-fortaleza-ce'
      }, {
        id: '1847',
        eventName: 'Recife/PE',
        address: 'R. Barão de Souza Leão, 451 - Boa Viagem, Recife - PE, 51030-300',
        startDate: '2020-08-25T03:00:00.000Z',
        endDate: '2020-08-26T03:00:00.000Z',
        urlFriendly: 'new-office-recife-pe'
      }, {
        id: '1848',
        eventName: 'Belém/PA',
        address: 'Av. Gov. José Malcher, 2927 - São Brás, Belém - PA, 66090-100',
        startDate: '2020-08-28T03:00:00.000Z',
        endDate: '2020-08-29T03:00:00.000Z',
        urlFriendly: 'new-office-belem-pa'
      }, {
        id: '1849',
        eventName: 'Goiânia/GO',
        address: 'R. T-36, 3588 - St. Bueno, Goiânia - GO, 74223-050',
        startDate: '2020-09-01T03:00:00.000Z',
        endDate: '2020-09-02T03:00:00.000Z',
        urlFriendly: 'new-office-goiania-go'
      }, {
        id: '1850',
        eventName: 'Rio de Janeiro/RJ',
        address: 'Av. Atlântica, 3264 - Copacabana, Rio de Janeiro - RJ, 22070-001',
        startDate: '2020-09-11T03:00:00.000Z',
        endDate: '2020-09-12T03:00:00.000Z',
        urlFriendly: 'new-office-rio-de-janeiro-rj'
      }],
      loaded: false,
      error: false
    }
  }

  componentDidMount () {
    this.setState({ eventsFiltered: this.state.events.filter(evento => moment(evento.endDate) >= moment()) })
  }

  render () {
    document.title = this.state.organizador.name ? this.state.organizador.name + ' - Evnts' : 'Carregando...'

    return (
      <div>
        <main>
          <Header />
          <section id='hotels'>
            {this.state.eventsFiltered && (this.state.eventsFiltered).map(event => <ShowCard key={event.id} organizador={this.state.organizador.id} {...event} />)}
          </section>
        </main>
        <Footer />
      </div>
    )
  }
}
